module.exports = __webpack_public_path__ + "img/Weapon_226.e04bb1c1.png";